module.exports = __webpack_public_path__ + "static/img/证书3.dff39e92.jpg";